import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { EndorseEffectiveDateRoutingModule } from "./endorse-effective-date-routing.module";
import { GlobalModule } from "../global/global.module";
import {EndorseEffectiveDateComponent} from "./endorse-effective-date.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    EndorseEffectiveDateRoutingModule,
    GlobalModule,
  ],
  declarations: [
    EndorseEffectiveDateComponent
  ],
  providers: [
    DatePipe
  ]
})
export class EndorseEffectiveDateModule {
}
